/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Datum',
  time: 'Tijd',
  hours: '{howMany} uur',
  minutes: '{howMany} min',
  today: 'Vandaag',
  duration: 'Duur',
  topic: 'Meetingtitel',
  voIPOnly: 'Alleen internetaudio',
  telephonyOnly: 'Alleen telefoon',
  both: 'Audio telefoon en internet',
  thirdParty: 'Audio derde partij',
  meetingId: 'Meeting-ID',
  password: 'Wachtwoord',
  video: 'Video',
  audio: 'Audio',
  scheduleFor: 'Plannen namens',
  [ASSISTED_USERS_MYSELF]: 'Mijzelf',
  meetingOptions: 'Meetingopties',
  meetingSettings: 'Meetinginstellingen',
  rcMeetingSettings: 'Instellingen videovergaderingen',
  audioOptions: 'Audio-opties',
  recurringMeeting: 'Terugkerende meeting',
  recurringNote: "Opmerking: schakel deze in bij het kiezen van 'Terugkerend'",
  joinBeforeHost: 'Deelnemers toestaan voor de host binnen te komen',
  turnOffCamera: 'Camera uitschakelen voor deelnemers',
  turnOffHostCamera:
    'Schakel camera uit voor host wanneer u deelneemt aan een meeting',
  requirePassword: 'Wachtwoord vereisen',
  enterPassword: 'Wachtwoord invoeren',
  setPassword: 'Wachtwoord instellen *',
  passwordEmptyError: 'Wachtwoord meeting vereist',
  rcmPasswordInvalidError:
    'Uw wachtwoord moet 1-10 tekens en cijfers lang zijn en mag geen symbolen bevatten, behalve @, * of -',
  rcmPasswordHintText:
    'Uw wachtwoord moet 1-10 tekens en cijfers lang zijn en mag geen symbolen bevatten, behalve @, * of -',
  usePersonalMeetingId: 'Persoonlijke meeting-ID gebruiken',
  pmiChangeConfirm:
    'Als u wijzigingen wilt aanbrengen voor uw persoonlijke meeting, ',
  changePmiSettings: 'wijzigt u de PMI-instellingen',
  pmiSettingChangeAlert:
    'Als u de instellingen wijzigt en deze meetings plant, gebruiken alle meetings met persoonlijke meeting-ID dezelfde nieuwe instellingen.',
  lockedTooltip: 'Deze instelling wordt beheerd door uw bedrijfsbeheerder',
  when: 'Wanneer',
  recurringDescribe:
    'Vergeet niet om terugkeren of herhaling aan te vinken in uw agenda-uitnodiging voor uw bezoekers.',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
